module.exports = __webpack_public_path__ + "static/img/2019-B.f05e64f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2019-B.png
// module id = 630G
// module chunks = 1